import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IicListComponent } from './iic-list/iic-list.component';
import { IicCreateComponent } from './iic-create/iic-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: IicListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: IicCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'iic-create/:id',
        component: IicCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IICRoutingModule { }
